<template>
  <div
    style="min-width: 400px; max-width: 450px; min-height: 200px; display: flex; justify-content: space-between; border: 1px solid black; border-radius: 16px; box-sizing: border-box; overflow: hidden;"
    :style="{ fontFamily: data.font }"
  >
    <table role="presentation" cellpadding="0" cellspacing="0" border="0" style="border-collapse:collapse; width: 100%" :style="{ 'font-family': data.font }">
      <tbody>
        <tr>
          <!-- Left Panel -->
          <td
            valign="top"
            style="padding: 32px 32px 16px 24px;"
            :style="data.imageUrl ? '250px' : '375px'"
          >
            <h2
              v-if="data.displayName"
              style="margin: 0; font-weight: 600;"
              :style="{ fontSize: useFontSizeScale(16).value }"
            >
              {{ data.displayName }}
            </h2>

            <p
              v-if="data.profession"
              style="margin: 2px 0 10px;"
              :style="{ fontSize: useFontSizeScale(11).value }"
            >
              {{ data.profession }}
            </p>

            <div>
              <span
                v-if="data.company"
                style="margin: 2px 0 10px; font-weight: 600;"
                :style="{ fontSize: useFontSizeScale(11).value }"
              >
                {{ data.company }}
              </span>
              <div
                v-if="data.address"
                style="margin-bottom: 4px; font-weight: 400;"
                :style="{ fontSize: useFontSizeScale(11).value }"
              >
                <span>{{ data.address }}</span>
              </div>
            </div>
          </td>

          <!-- Right panel -->
          <td valign="middle" :style="{ backgroundColor: data.theme?.background || '#000', 'min-width': '120px'}">
            <table role="presentation" cellpadding="0" cellspacing="0" border="0" :width="data.imageUrl ? '50' : '35'" :align="data.imageUrl ? 'center' : 'right'">
              <tbody>
                <tr>
                  <!-- Image -->
                  <td v-if="data.imageUrl" valign="middle" style="padding:16px;">
                    <img
                      width="128"
                      height="128"
                      :src="data.imageUrl"
                      alt=""
                      :style="data._placeholderFields?.has?.('imageUrl')
                        ? {
                            width: '128px',
                            height: 'auto',
                            objectFit: 'contain',
                            display: 'block'
                          }
                        : {
                            display: 'block',
                            maxWidth: '128px',
                            maxHeight: '128px',
                            width: 'auto',
                            height: 'auto'
                          }"
                      />
                  </td>

                  <!-- Icons -->
                  <td valign="middle" align="right" style="padding: 16px 12px 16px 0px;">
                    <table role="presentation" cellpadding="0" cellspacing="0" border="0">
                      <tbody>
                        <tr v-for="{ field, value } of dataMap" :key="field">
                          <td style="padding:6px 0;">
                            <a
                              v-if="data[`${field}IconUrl`]"
                              :href="`https://www.${field}.com/${value}`"
                              style="display:block; text-decoration:none;min-width: 16px; min-height: 16px;"
                              target="_blank"
                            >
                              <img
                                :src="data[`${field}IconUrl`]"
                                :alt="altTexts[field]"
                                width="16"
                                height="16"
                                style="display:block; border:0;"
                              />
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { useFontSizeScale } from '@/io.ox/mail/settings/signatures/signature-designer/composables/useFontSizeScale'
import { computed } from 'vue'

const availableFields = [
  'address',
  'displayName',
  'profession',
  'company',
  'theme',
  'instagram',
  'facebook',
  'linkedin',
  'youtube',
  'x',
  'imageUrl',
  'font',
  'fontSize'
]

const { data } = defineProps({
  data: { type: Object, required: true }
})

defineExpose({
  availableFields,
  imageSlots: [
    { field: 'imageUrl', aspect: 'square' }
  ],
  previewTheme: { background: '#000000', text: 'white' }
})

const altTexts = {
  instagram: 'Instagram',
  facebook: 'Facebook',
  linkedin: 'LinkedIn',
  youtube: 'YouTube',
  x: 'X (Twitter)'
}

const dataMap = computed(() => {
  return Object.entries({
    instagram: data.instagram,
    facebook: data.facebook,
    linkedin: data.linkedin,
    youtube: data.youtube,
    x: data.x
  })
    .map(([field, value]) => ({ field, value }))
    .filter(pair => pair.value !== '')
})
</script>
